module.exports = __webpack_public_path__ + "img/xy.9972f1b4.png";